module.exports = __webpack_public_path__ + "static/media/wppicon.360c7eb1.png";